/**
 * Role checks that were defined more than once.
 *
 * `userIsAdmin` existed verbatim in both offline-asset notice utilities. It
 * accepts either shape a user record arrives in — a `roles` array, or a single
 * `role` string — because both are in use.
 *
 * Note: `roles.includes('admin')` is still written inline in roughly ten other
 * places across the frontend. Consolidating those is a separate survey, not
 * part of TCA-26081110.
 */

export function userIsAdmin(user) {
  const roles = Array.isArray(user?.roles)
    ? user.roles
    : (user?.role ? [user.role] : []);
  return roles.includes('admin');
}

export default userIsAdmin;
